export default __webpack_public_path__ + "static/media/destroyer_animated.41ebcf23.gif";